// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"4e0b7d1d","81":"95ef96c1","84":"e95ebdb8","232":"14782575","446":"c8ec77d6","525":"ae14144f","586":"e792b1f7","652":"70ae560f","749":"24966958","807":"4328f643","877":"3a077e88","893":"61ec9adc","971":"1bea5fb6","993":"e79f22c4"}[chunkId] + ".chunk.js";
};